import { render, staticRenderFns } from "./cp-files.vue?vue&type=template&id=52df90be&"
import script from "./cp-files.vue?vue&type=script&lang=js&"
export * from "./cp-files.vue?vue&type=script&lang=js&"
import style0 from "./cp-files.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports